export default __webpack_public_path__ + "static/media/flex.658972d0.png";